import { useState } from "react";

const SIDES = {
  student: {
    tab: "I'm a student",
    headline: "Find out what you're naturally drawn to, what you're good at, and careers you may never have heard of.",
    points: ["There are no right or wrong answers.", "Pause anytime and pick up right where you left off.", "Questions, chosen for your exact class."],
  },
  parent: {
    tab: "I'm a parent",
    headline: "Understand your child better, open a calm conversation about the future, and support their choices with confidence.",
    points: ["A conversation guide for the family, with simple questions to talk through together at home.", "Courses, colleges and universities worth a closer look, from Class 9.", "A one-on-one chat with a career counsellor, on request."],
  },
};

export default function ForEveryone() {
  const [side, setSide] = useState("student");
  const s = SIDES[side];
  return (
    <section className="ds-section bg-ds-cream" data-testid="landing-for-everyone">
      <div className="container-x grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4" data-reveal>
          <div role="tablist" aria-label="Who is reading" className="inline-flex rounded-full border border-ds-plum/20 bg-white p-1">
            {Object.entries(SIDES).map(([k, v]) => (
              <button key={k} role="tab" aria-selected={side === k} onClick={() => setSide(k)} data-testid={`for-toggle-${k}`}
                className={`min-h-[44px] rounded-full px-5 text-[15px] font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-plum ${side === k ? "bg-ds-plum text-white" : "text-ds-plum hover:bg-ds-plum/5"}`}>
                {v.tab}
              </button>
            ))}
          </div>
        </div>
        <div key={side} className="lg:col-span-8 rise [animation-duration:300ms]" role="tabpanel" data-testid={`for-${side === "student" ? "students" : "parents"}`}>
          <p className="font-display text-[26px] sm:text-4xl font-semibold leading-[1.2] text-ds-plumdeep">{s.headline}</p>
          <ul className="mt-8 grid sm:grid-cols-3 gap-6 border-t border-ds-plum/15 pt-6">
            {s.points.map((p) => (
              <li key={p} className="flex gap-3 text-[15px] text-ds-ink leading-relaxed"><span className="mt-2 h-2.5 w-2.5 shrink-0 rounded-full bg-ds-amber" />{p}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
